// ============================================================================
// ⚠️  GENERATED FILE — DO NOT EDIT MANUALLY
// ============================================================================
//
// This file is generated and maintained by the Post Office CLI install script.
//
// AI AGENTS (Rovo Dev, Cursor, Copilot, etc.) — DO NOT automatically add
// message registrations, imports, or modify this file. Doing so bypasses
// important validation, priority ordering, and router registration logic.
//
// To register a message template, run from inside the message directory:
//
//   yarn placement:v2 install
//
// The CLI handles all necessary changes to this file automatically.
// ============================================================================

import { PlacementFrontend } from '@post-office/browser--jira-werewolves/jira-for-you-crossflow-solutions';

import { MessageFrontend as createMessageFrontendJiraCrossflowRecommendationJpd } from '@post-office/browser--jira-werewolves/jira-crossflow-recommendation-jpd/placements/in-app-v2/jira-for-you-crossflow-solutions';
import { MessageFrontend as createMessageFrontendJiraCrossflowRecommendationJsm } from '@post-office/browser--jira-werewolves/jira-crossflow-recommendation-jsm/placements/in-app-v2/jira-for-you-crossflow-solutions';
import { MessageFrontend as createMessageFrontendJiraCrossflowRecommendationConfluence } from '@post-office/browser--jira-werewolves/jira-crossflow-recommendation-confluence/placements/in-app-v2/jira-for-you-crossflow-solutions';
import { MessageFrontend as createMessageFrontendJiraCrossflowRecommendationJsmOperations } from '@post-office/browser--jira-werewolves/jira-crossflow-recommendation-jsm-operations/placements/in-app-v2/jira-for-you-crossflow-solutions';

import { withI18n } from './i18n';

import { type PlacementRendererStage } from '@post-office/message-maker-browser/types';
import { type JiraForYouCrossflowSolutionsProps } from '@post-office/browser--jira-werewolves/jira-for-you-crossflow-solutions/registry-props';
import { type ComponentType } from 'react';

export type {
	JiraForYouCrossflowSolutionsStatus,
	JiraForYouCrossflowSolutionsProps,
} from '@post-office/browser--jira-werewolves/jira-for-you-crossflow-solutions/registry-props';

const messageFrontends = [
	createMessageFrontendJiraCrossflowRecommendationJpd({
		messageTemplateId: 'jira-crossflow-recommendation-jpd',
	}),
	createMessageFrontendJiraCrossflowRecommendationJsm({
		messageTemplateId: 'jira-crossflow-recommendation-jsm',
	}),
	createMessageFrontendJiraCrossflowRecommendationConfluence({
		messageTemplateId: 'jira-crossflow-recommendation-confluence',
	}),
	createMessageFrontendJiraCrossflowRecommendationJsmOperations({
		messageTemplateId: 'jira-crossflow-recommendation-jsm-operations',
	}),
];

export const RawPlacement: PlacementRendererStage<JiraForYouCrossflowSolutionsProps> =
	PlacementFrontend.createPlacementFrontendComponent({
		messageTemplates: messageFrontends,
	});

export const Placement: ComponentType<
	Omit<JiraForYouCrossflowSolutionsProps, 'ref'> & {
		ref?: unknown;
	}
> = withI18n(RawPlacement);

export const SSRPlacement: PlacementRendererStage<JiraForYouCrossflowSolutionsProps> = RawPlacement;
